import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge3MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge3MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge3MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge3MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge3MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge3MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge3MasterReference } =
  verificationDischarge3MasterReferenceSlice.actions;

export default verificationDischarge3MasterReferenceSlice.reducer;
